const User = {
    getTwitterUsername: function (user){
        const twitterLink = user.profile.twitterLink;
        if (!twitterLink){
            return ""
        }
        const arr = twitterLink.split("/");
        return arr[arr.length-1];
    },
    getFacebookUsername: function (user){
        const facebookLink = user.profile.facebookLink;
        if (!facebookLink){
            return ""
        }
        const arr = facebookLink.split("/");
        return arr[arr.length-1];
    },
    getBirthday: function (user){
        const birthday = user.profile.birthday;
        if (!birthday){
            return ""
        }
        const arr = birthday.split("-").map(Number);
        return {year: arr[0], month: arr[1], day: arr[2]}
    },
    getPinnedPostIds: function (user){
        let ids = [];
        if (user.postPinnedSet){
            user.postPinnedSet.edges.forEach(edge => {
                ids.push(edge.node.id);
            });
        }
        return ids;
    }
};

export default User;
